import React from "react";
import { getPeriodRangeByLabel } from "../constants";

export const SubtotalCell = ({
  valor,
  monthIndex,
  tipo,
  periodo,
  year,
  vertical,
  getDesglose,
  getMoneda,
  getDisplayValue,
  onOpenModal,
  currentMonthIndex,
}) => {
  const esTotal = vertical === null;

  if (!valor || valor === 0) {
    // Verificar si el año anterior tiene datos para mostrar triángulo rojo
    let indicadorVacio = null;

    if (year === "2026" && vertical !== null) {
      let valor2025 = 0;

      if (monthIndex !== null) {
        const d2025 = getDesglose(2025, monthIndex + 1, monthIndex + 1, tipo);
        valor2025 = d2025[vertical] || 0;
      } else if (periodo) {
        const range = getPeriodRangeByLabel(periodo);
        if (range) {
          const d2025 = getDesglose(2025, range.start, range.end, tipo);
          valor2025 = d2025[vertical] || 0;
        }
      }
      const mostrarIndicador = tipo === "facturacion" ? true : monthIndex === null || monthIndex <= currentMonthIndex;
      if (mostrarIndicador) {
        indicadorVacio =
          valor2025 > 0 ? (
            <span style={{ color: "#dc3545", fontSize: "0.69rem" }}>▼</span>
          ) : (
            <span style={{ color: "#007bff", fontSize: "1rem" }}>=</span>
          );
      }
    }

    return (
      <td
        className="text-end"
        style={{
          fontWeight: esTotal ? "700" : "normal",
          backgroundColor: esTotal ? "rgba(0,0,0,0.7)" : "transparent",
          color: esTotal ? "white" : "inherit",
          position: "relative",
          paddingLeft: indicadorVacio ? "18px" : undefined,
        }}
      >
        {indicadorVacio && (
          <span style={{ position: "absolute", left: "6.9px", top: "50%", transform: "translateY(-50%)" }}>
            {indicadorVacio}
          </span>
        )}
        -
      </td>
    );
  }

  const isCierres = tipo === "cierres";
  const isFacturacion = tipo === "facturacion";

  if (!isCierres && !isFacturacion)
    return (
      <td className="text-end">
        {getMoneda()}
        {getDisplayValue(valor)}
      </td>
    );

  // Indicador de comparación con año anterior
  let indicador = null;
  if (year === "2026" && vertical !== null) {
    let valor2025 = 0;

    if (monthIndex !== null) {
      const d2025 = getDesglose(2025, monthIndex + 1, monthIndex + 1, tipo);
      valor2025 = d2025[vertical] || 0;
    } else if (periodo) {
      const range = getPeriodRangeByLabel(periodo);
      if (range) {
        const d2025 = getDesglose(2025, range.start, range.end, tipo);
        valor2025 = d2025[vertical] || 0;
      }
    }

    const mostrarIndicador = tipo === "facturacion" ? true : monthIndex === null || monthIndex <= currentMonthIndex;

    if (mostrarIndicador) {
      if (valor > valor2025) {
        indicador = <span style={{ color: "#28a745", fontSize: "0.69rem" }}>▲</span>;
      } else if (valor < valor2025) {
        indicador = <span style={{ color: "#dc3545", fontSize: "0.69rem" }}>▼</span>;
      } else {
        indicador = <span style={{ color: "#007bff", fontSize: "1rem" }}>=</span>;
      }
    }
  }

  // Solo permitir modal en filas mensuales
  const permitirModal = monthIndex !== null;

  const handleClick = () => {
    if (!permitirModal) return;
    onOpenModal(monthIndex, tipo, year, vertical, periodo);
  };

  return (
    <td
      className="text-end"
      style={{
        cursor: permitirModal ? "pointer" : "default",
        fontWeight: esTotal ? "700" : "normal",
        backgroundColor: esTotal ? "rgba(0,0,0,0.7)" : "transparent",
        color: esTotal ? "white" : "inherit",
        position: "relative",
        paddingLeft: "18px",
      }}
      onClick={permitirModal ? handleClick : undefined}
      title={permitirModal ? `Ver detalle de ${isFacturacion ? "facturación" : "cierres"}` : undefined}
    >
      {indicador && (
        <span style={{ position: "absolute", left: "6.9px", top: "50%", transform: "translateY(-50%)" }}>
          {indicador}
        </span>
      )}
      {getMoneda()}
      {getDisplayValue(valor)}
    </td>
  );
};
